// extracted by mini-css-extract-plugin
module.exports = {"image":"No","placeholder":"Oo","videoPlaceholder":"Po","playVideoImgOverlay":"Qo","playVideoButton":"Ro","imageButton":"So","carouselChild":"To","compact":"Uo"};